package com.example.mystybag.login.views

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.ui.unit.dp
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import com.example.mystybag.common.resources.SR
import com.example.mystybag.common.ui.components.native.DefaultButton
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.core.expected.PlatformHelper
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.core.ui.theme.LocalTheme.p12
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p20
import com.example.mystybag.core.ui.theme.LocalTheme.p24
import com.example.mystybag.core.ui.theme.LocalTheme.p32
import com.example.mystybag.login.logic.MerchantRegistrationSuccessViewModel
import com.example.mystybag.login.views.components.MerchantRegistrationWebBoundedColumn
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.compose.stringResource

@Composable
fun MerchantRegistrationSuccessView(viewModel: MerchantRegistrationSuccessViewModel) {
    if (PlatformHelper.isWeb) {
        UIView(
            viewModel = viewModel,
            modifier = Modifier.fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) { _ ->
            MerchantRegistrationWebBoundedColumn(Modifier.fillMaxSize()) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .verticalScroll(rememberScrollState())
                        .padding(top = p20, bottom = p8),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.Top
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .widthIn(max = 380.dp),
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.spacedBy(p32)
                    ) {
                        Image(
                            painter = painterResource(SRC.images.merchant_registration_success_illustration),
                            contentDescription = null,
                            modifier = Modifier
                                .size(246.dp, 152.dp)
                                .padding(top = p24),
                            contentScale = ContentScale.Fit
                        )

                        Column(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalAlignment = Alignment.CenterHorizontally,
                            verticalArrangement = Arrangement.spacedBy(p12)
                        ) {
                            Texts.DisplayMedium(
                                text = stringResource(SR.strings.merchant_registration_success),
                                textAlign = TextAlign.Center,
                                modifier = Modifier.fillMaxWidth()
                            )

                            Texts.BodyMedium(
                                text = stringResource(SR.strings.merchant_registration_success_message),
                                textAlign = TextAlign.Center,
                                modifier = Modifier.fillMaxWidth()
                            )
                        }
                    }

                    Spacer(modifier = Modifier.height(p32))

                    DefaultButton(
                        caption = stringResource(SR.strings.proceed_to_login),
                        callback = { viewModel.onProceedToLogin() },
                        modifier = Modifier.fillMaxWidth()
                    )
                }
            }
        }
        return
    }

    UIView(
        viewModel = viewModel,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(start = p16, top = p20, end = p16, bottom = 0.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Top
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .widthIn(max = 380.dp),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(p32)
            ) {
                Image(
                    painter = painterResource(SRC.images.merchant_registration_success_illustration),
                    contentDescription = null,
                    modifier = Modifier
                        .size(246.dp, 152.dp)
                        .padding(top = p24),
                    contentScale = ContentScale.Fit
                )

                Column(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(p12)
                ) {
                    Texts.DisplayMedium(
                        text = stringResource(SR.strings.merchant_registration_success),
                        textAlign = TextAlign.Center,
                        modifier = Modifier.fillMaxWidth()
                    )

                    Texts.BodyMedium(
                        text = stringResource(SR.strings.merchant_registration_success_message),
                        textAlign = TextAlign.Center,
                        modifier = Modifier.fillMaxWidth()
                    )
                }
            }

            Spacer(modifier = Modifier.weight(1f))

            DefaultButton(
                caption = stringResource(SR.strings.proceed_to_login),
                callback = {
                    viewModel.onProceedToLogin()
                },
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(bottom = p8)
            )
        }
    }
}
